import React from 'react';
import { Box, Typography, TextField, MenuItem, Button } from '@mui/material';

const questions = [
  "Question 1: SCT Present",
  "Question 2: Photopack present",
  "Question 3: Rightcheck present",

];

const scores = ['Pass','Pass (With Feedback)','Improvement Required','Significant Improvement Required'];

const result = {
    "Question 1: SCT Present": 'Pass',
    "Question 2: Photopack present": 'Pass (With Feedback)',
    "Question 3: Rightcheck present": 'Improvement Required',
  };

const ScoreCard = () => {
  return (
    <Box sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom>
        Audit Result / Completed Scorecard for: CW-014725
        </Typography>
        <Typography variant="h5" gutterBottom>
            2 Stanford Close Laceby
        </Typography>
        <form>
        {questions.map((question, index) => (
          <Box key={index} sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom>
              {question}
            </Typography>
            <TextField
              select
              fullWidth
              variant="outlined"
              label="Score"
              value={result[question]}
              InputProps={{
                readOnly: true,
              }}
            >
              {scores.map((score) => (
                <MenuItem key={score} value={score}>
                  {score}
                </MenuItem>
              ))}
            </TextField>
          </Box>
        ))}
        <Typography variant="h6" gutterBottom>
          Auditor Comments
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={4}
          variant="outlined"
          label="Comments"
          InputProps={{
            readOnly: true,
          }}
        />
      </form>
    </Box>
  );
};

export default ScoreCard;